import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/header';
import { Alert } from '../../components/modal';

import { useError } from '../../hooks/useError';

import { TransactionContext } from '../../contexts/TransactionContext';
import { isEmpty } from '../../helpers/validation';

import { getTickets } from '../../services/product';

import { EVENTID } from '../../helpers/constants';

import { getCPS } from '../../services/cp';

import { Input, ListGroup, ListGroupItem } from 'reactstrap';
export default function Login() {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const [cps, setCps] = useState([]);
  const [cp, setCp] = useState('');
  const [cp_code, setCp_code] = useState('');

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isListVisible, setIsListVisible] = useState(false);
  const { fillCp, cpSelected } = useContext(TransactionContext);
  const { goToFieldWithError } = useError();

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    goToFieldWithError('home-cp');
  };

  const handleNext = async (e) => {
    e.preventDefault();
    const result = cps.find(
      (x) => x.name.toLowerCase() === cp.toLowerCase() && x.code === cp_code,
    );
    // console.log(cp);

    if (!result) {
      setMessage('Código do CP não confere');
      openModal();
      return;
    }
    // if (cpSelected?.focal_point?.trim() === '') {
    //   setMessage('Ponto focal não preenchido');
    //   openModal();
    //   return;
    // }
    if (result && result?.available) {
      fillCp('code', result.code);
      fillCp('name', result.name);
      fillCp('count', result.count);
      navigate('/carrinho');
    } else {
      setMessage('CP não tem vagas disponíveis');
      openModal();
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value;
    setCp(term);
    const filtered = cps.filter((option) =>
      option.name.toLowerCase().includes(term.toLowerCase()),
    );
    setFilteredOptions(filtered);
    setIsListVisible(true);
  };

  const handleSelect = (selectedOption) => {
    setCp(selectedOption.name);
    setIsListVisible(false);
    if (!selectedOption.available) {
      setMessage('CP não tem vagas disponíveis');
      openModal();
    }
  };

  const toggleListVisibility = () => {
    setIsListVisible(!isListVisible);
  };

  const modal = (
    <Alert
      isOpen={open}
      toggle={closeModal}
      message={message}
    />
  );

  const associatedLogin = (
    <form
      onSubmit={handleNext}
      className='d-flex flex-column gap-3'
    >
      <div className='cp-search'>
        <label
          htmlFor='home-cp'
          className='form-label'
        >
          Selecione o seu CP *
        </label>
        <Input
          id='home-cp'
          placeholder='Pesquisar...'
          value={cp}
          onChange={handleSearch}
          onClick={toggleListVisibility}
          autoComplete='off'
          role='combobox'
          aria-expanded={isListVisible}
          aria-controls='home-cp-list'
        />
        {isListVisible && filteredOptions.length > 0 && (
          <ListGroup
            id='home-cp-list'
            role='listbox'
            className='cp-search__list'
          >
            {filteredOptions.map((cp, index) => (
              <ListGroupItem
                key={index}
                value={cp.name}
                action
                role='option'
                onClick={() => handleSelect(cp)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setCp(cp.name);
                    setIsListVisible(false);
                    if (!cp.available) {
                      setMessage('CP não tem vagas disponíveis');
                      openModal();
                    }
                  }
                }}
                tabIndex={0}
              >
                {cp.name}
              </ListGroupItem>
            ))}
          </ListGroup>
        )}
      </div>
      <div>
        <label
          htmlFor='cp_code'
          className='form-label'
        >
          Código do CP *
        </label>
        <Input
          id='cp_code'
          placeholder='Digite o código do CP'
          value={cp_code}
          onChange={(e) => setCp_code(e.target.value)}
          onFocus={() => setIsListVisible(false)}
          autoComplete='off'
        />
      </div>
      <button
        type='submit'
        className='btn btn-primary btn-lg w-100 mt-2'
      >
        <i
          className='bi bi-box-arrow-in-right me-2'
          aria-hidden='true'
        />
        Entrar
      </button>
    </form>
  );

  useEffect(() => {
    const fetch = async () => {
      document.title = t('title');
      const response = await getCPS();
      setCps(response);
      setFilteredOptions(response);
    };
    fetch();
  }, [open, t]);

  return (
    <>
      {modal}
      <Header showFacts={false}>
        <section className='hero__content'>
          <h2 className='site-title site-title--sm mb-4'>{t('login.title')}</h2>
          {associatedLogin}
        </section>
      </Header>
    </>
  );
}
